import { useStore } from 'vuex'

export default {
    name: "SourceExternalLinks",
    props: {
        name: {
            type: String,
            required: true
        },
        links: {
            type: Array,
            default: () => []
        }
    },
    setup(props) {
        const store = useStore()

        const getLabel = (labelKey) => store.getters['labels/getLabel']({
            labelCollection: 'SourceExternalLinks',
            labelKey
        })

        const title = getLabel('title')?.replace('{navn}', props.name)

        return {
            getLabel,
            title
        }
    }
}